module.exports = function() {
  return new Worker(__webpack_public_path__ + "237977c732907ecbfa32.worker.js");
};